module.exports = __webpack_public_path__ + "img/12_l_uk.3ffd49b5.svg";